import { useContext, useCallback } from 'react';
import { Context } from 'context';
import { US_CONFIG } from 'config/country-configs';

export const useCountryConfig = () => {
    const { state: { countryConfig = {} } } = useContext(Context);

    const currentConfig = countryConfig;

    const formatCurrency = useCallback((amount) => {
        if (!amount && amount !== 0) return '';
        return new Intl.NumberFormat(currentConfig.currency.format, {
            style: 'currency',
            currency: currentConfig.currency.code,
        }).format(amount);
    }, [currentConfig]);

    const formatDate = useCallback((date) => {
        if (!date) return '';
        const dateObj = typeof date === 'string' ? new Date(date) : date;
        return new Intl.DateTimeFormat(currentConfig.dateFormat.display).format(dateObj);
    }, [currentConfig]);

    const validateInput = useCallback((type, value) => {
        const validation = currentConfig.validation[type];
        if (!validation) {
            return { isValid: true, message: '' };
        }

        const isValid = validation.pattern.test(value);
        return {
            isValid,
            message: isValid ? '' : validation.message
        };
    }, [currentConfig]);

    const getAddressConfig = useCallback(() => {
        return {
            labels: currentConfig.address.labels,
            placeholders: currentConfig.address.placeholders,
            requiredFields: currentConfig.address.requiredFields,
            states: currentConfig.address.states,
            postalCodePattern: currentConfig.address.postalCodePattern,
        };
    }, [currentConfig]);


    const getPhoneConfig = useCallback(() => {
        return {
            pattern: currentConfig.phone.pattern,
            format: currentConfig.phone.format,
            placeholder: currentConfig.phone.placeholder,
            countryCode: currentConfig.phone.countryCode,
        };
    }, [currentConfig]);

    return {
        config: currentConfig,
        countryCode: currentConfig?.code,
        symbol: currentConfig?.currency?.symbol,
        countryName: currentConfig?.name,
        genderList: currentConfig?.genderList,
        biologicalGenderList: currentConfig?.biologicalGenderList,
        biologicalSexRequired: currentConfig?.biologicalSexRequired,
        formatCurrency,
        formatDate,
        validateInput,
        getAddressConfig,
        getPhoneConfig,
        isGBP: currentConfig?.code === 'GB',
        isUS: currentConfig?.code === 'US',
    };
};